/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateTaggedFileCountsDataSchema = z.object({
	cv: z.number().default(0),
})

export type CandidateTaggedFileCountsDataSchema = z.infer<typeof candidateTaggedFileCountsDataSchema>
